import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Register from "./Register";
import Login from "./Login";
import Dashboard from "./Dashboard";
import PasswordReset from "./PasswordReset";
import TwoFactorAuth from "./TwoFactorAuth";
import SetupMfa from "./SetupMfa";
import AISearch from "./AISearch";

function ProtectedRoute({ children, allowWithoutMfa = false }) {
  const { user, isLoading, error, mfaEnabled } = useAuth();

  // Debug: log what the auth context sees
  if (!isLoading) {
    console.log("[ProtectedRoute] user:", user?.email, "mfaEnabled:", mfaEnabled, "user fields:", user ? Object.keys(user) : "null");
  }
  
  if (isLoading && !error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '10px'
      }}>
        <div>Loading...</div>
      </div>
    );
  }
  
  if (!user) return <Navigate to="/login" />;

  if (!allowWithoutMfa && !mfaEnabled) {
    return <Navigate to="/setup-mfa" />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { user, isLoading, error } = useAuth();

  console.log("[PublicRoute] isLoading:", isLoading, "user:", user?.email || null, "error:", error?.message || null);
  
  if (isLoading && !error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading...
      </div>
    );
  }
  
  return !user ? children : <Navigate to="/dashboard" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      <Route path="/register" element={<Register />} />
      <Route path="/password-reset" element={
        <PublicRoute>
          <PasswordReset />
        </PublicRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/setup-mfa" element={
        <ProtectedRoute allowWithoutMfa>
          <SetupMfa />
        </ProtectedRoute>
      } />
      <Route path="/settings/2fa" element={
        <ProtectedRoute>
          <TwoFactorAuth />
        </ProtectedRoute>
      } />
      <Route path="/ai-search" element={
        <ProtectedRoute>
          <AISearch />
        </ProtectedRoute>
      } />
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
